import { inject } from "@angular/core";
import { CanMatchFn, Router, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";

import { AuthFacade } from "../state/auth.facade";

/**
 * Blocks Viewer (read-only) users from routes they should not access, such as
 * /upload and /admin. Viewers are redirected to the homepage dashboard. Runs as
 * a `canMatch` guard so it also intercepts the post-login redirect, not just
 * in-app navigation.
 */
export const ViewerGuard: CanMatchFn = (): Observable<true | UrlTree> => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.user$.pipe(
    map((user) => (user?.isViewer ? router.createUrlTree(["/homepage"]) : true))
  );
};
